import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const TBody = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tbody>
      {moduleData.list &&
        moduleData.list.map((item: any, index: number) => (
          <tr key={`${index}_row`}>
            <td style={{ minWidth: '120px', width: '120px' }}>
              {formatDate(item.date)}
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              {isView ? (
                formatDate(item.tool_unloading_date)
              ) : (
                <DatePickerMui
                  value={moment(item.tool_unloading_date)}
                  onChange={(date) => {
                    item.tool_unloading_date = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              <TableInput
                isView={true}
                name="machine_no"
                type="text"
                value={item.machine_no}
              />
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              <TableInput
                isView={true}
                name="actual_prod"
                type="number"
                value={item.actual_prod}
                // onChange={(e) => {
                //   item.actual_prod = e.target.value;
                //   calculateCumulative();
                //   setRender((prev) => !prev);
                // }}
              />
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              <TableInput
                isView={true}
                name="comulative"
                type="text"
                value={item.comulative}
              />
            </td>
            <td
              style={{
                ...(item.status === 'RED (R)' && { background: '#e03131' }),
                minWidth: '160px',
                width: '160px',
              }}
            >
              {item.status}

              {/* if the client want to manually set the status then go for it and in calculateCumulative in createToolHistory file remove item.status  */}
              {/* {isView ? (
                item.status
              ) : (
                <CustomSelect
                  name="status"
                  value={item.status}
                  sx={{
                    background: `
                      ${
                        (item.status === 'GREEN (G)' && '#40c057') ||
                        (item.status === 'YELLOW (Y)' && '#ffe066') ||
                        (item.status === 'RED (R)' && '#e03131')
                      }
                    `,
                  }}
                  onChange={(e) => {
                    item.status = e.target.value;
                    setRender((prev) => !prev);
                  }}
                >
                  <MenuItem value="">NONE</MenuItem>
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT OK">NOT OK</MenuItem>
                </CustomSelect>
              )} */}
            </td>
            <td>
              <TableInput
                isView={isView}
                name="reason"
                type="text"
                value={item.reason}
                onChange={(e) => {
                  item.reason = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="action_taken"
                type="text"
                value={item.action_taken}
                onChange={(e) => {
                  item.action_taken = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="updated_by"
                type="text"
                value={item.updated_by}
                onChange={(e) => {
                  item.updated_by = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="remarks"
                type="text"
                value={item.remarks}
                onChange={(e) => {
                  item.remarks = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
          </tr>
        ))}
    </tbody>
  );
};

export default TBody;
